import { render, staticRenderFns } from "./PolicyIndex.vue?vue&type=template&id=6847b20e&scoped=true&"
import script from "./PolicyIndex.vue?vue&type=script&lang=js&"
export * from "./PolicyIndex.vue?vue&type=script&lang=js&"
import style0 from "./PolicyIndex.vue?vue&type=style&index=0&id=6847b20e&prod&lang=css&"
import style1 from "./PolicyIndex.vue?vue&type=style&index=1&id=6847b20e&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6847b20e",
  null
  
)

export default component.exports